module.exports = __webpack_public_path__ + "static/media/gerda imhof.efc2b2a6.jpg";